module.exports = __webpack_public_path__ + "img/elementlengths_jakp.9f525f81.png";